import type { ReactElement } from 'react';

export function TypingIndicator(): ReactElement {
  return (
    <span
      role="status"
      aria-label="O assistente está digitando"
      className="inline-flex items-center gap-1 px-1 py-1.5"
    >
      <Dot delayMs={0} />
      <Dot delayMs={150} />
      <Dot delayMs={300} />
    </span>
  );
}

function Dot({ delayMs }: { delayMs: number }): ReactElement {
  return (
    <span
      aria-hidden
      className="bg-muted-foreground/70 inline-block size-1.5 rounded-full motion-safe:animate-[chat-bounce_900ms_ease-in-out_infinite]"
      style={{ animationDelay: `${delayMs}ms` }}
    />
  );
}
